<template>

    <div class="explanation" v-html="getExplanation"></div>

    <div class="mode-change-buttons" v-if=" 'jeunes' === store.getters.audienceMode ">
        <div class="register-link-container">
            <button type="button" class="link-register link-show-all link-mode-toggle"
                    @click="changeMode('register')">{{ copydeck?.btnRegisterToggle?.fr ?? '' }}
            </button>
        </div>

        <button type="button" class="text-link link-login link-mode-toggle"
                @click="changeMode('login')">{{ copydeck?.btnAlreadyRegisteredToggle?.fr ?? '' }}
        </button>


    </div>

</template>


<script>
export default {
    name : "Explanation",
}
</script>
<script setup>

import { useStore } from 'vuex';
import { computed } from 'vue';

import { changeMode } from '../composables';

// store
let store    = useStore();
let copydeck = computed( () => store.state.copydeck );

let getExplanation = computed( () =>
{

    let wantedText = '';
    if ( "jeune-action-profs-seul" === store.getters.audienceMode )
    {

        wantedText = copydeck?.value?.explanationJeunesActionProfsSeulement?.fr ?? 'Désolé';

    } else    if ( "profs-seulement" === store.getters.audienceMode )
    {

        wantedText = copydeck?.value?.explanationForSignupProfsOnly?.fr ?? 'Désolé';

    } else if ( "profs" === store.getters.audienceMode )
    {

        wantedText = copydeck?.value?.explanationForJeunesOnly?.fr ?? 'Désolé';

    } else
    {

        wantedText = (copydeck?.value?.explanationForSignupJeunes?.fr ?? 'Désolé')

    }

    return wantedText.replace( '[AS]', '<div class="as-logo-container"><img src="/images/logo-rouge-no-text.svg" alt="Logo des As de l\'info"></div>' ) ?? '';

} )
</script>

<style scoped>

</style>
